import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router';

import { AuthOverlay } from '@/pages/Auth';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { setAppNavigate } from '@/shared/services/helpers/navigate-helper';
import MainLoader from '@/shared/ui/main-loader';
import { ErrorFallback } from '@/shared/widgets';
import { useAppSelector } from '@/store';

import { LanguageGuard } from './language.guard';
import ThemeProvider from './theme.provider';

const AppProvider: React.FC = () => {
  const { navigate } = useAppNavigate();
  const location = useLocation();
  const { headerConfig, isLoading } = useAppSelector((state) => state.app);

  setAppNavigate(navigate);

  useEffect(() => {
    document.title = `MONI ${headerConfig.helmetTitle ? `/ ${headerConfig.helmetTitle}` : ''}`;
  }, [headerConfig]);

  return (
    // Тема оболочки — только внутри AppProvider: админка (отдельная ветка роутера) её не получает.
    <ThemeProvider>
      <LanguageGuard>
        <Helmet titleTemplate="MONI / %s" defaultTitle="MONI">
          <title>{headerConfig.helmetTitle}</title>
        </Helmet>
        {isLoading > 0 && <MainLoader fullScreen />}
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          resetKeys={[location.pathname]}
        >
          <Outlet />
        </ErrorBoundary>
        <AuthOverlay />
      </LanguageGuard>
    </ThemeProvider>
  );
};

export default AppProvider;
